import styled from 'styled-components';
import { timingDefault } from '../../constants';
export const Container = styled.div `
  ${({ theme: { device: { fromMd }, }, }) => `
  ${fromMd} {
    display: inline-block;
    position: relative;

    &::after {
      background: currentColor;
      bottom: -4px;
      content: "";
      height: 1px;
      left: 0;
      position: absolute;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform ${timingDefault} ease-in;
      width: 100%;
    }

    &:hover::after {
      transform: scaleX(1);
    }

    a {
      display: inline-block;
    }
  }`}
`;
//# sourceMappingURL=styles.js.map